module.exports = __webpack_public_path__ + "img/microphone-img.5d3f58d1.svg";